export const AGB = () => {
    return (
        <div className="section-padding container-custom min-h-screen !pt-48 pb-20">
            <h1 className="text-3xl md:text-5xl font-semibold text-[#F1F5F9] mb-12 font-['DM_Sans']">
                Allgemeine Geschäftsbedingungen (AGB)
            </h1>

            <div className="space-y-8 text-[#94A3B8] max-w-3xl leading-relaxed">
                <p className="italic text-sm mb-8">Stand: Februar 2026</p>

                <section>
                    <h2 className="text-xl text-[#F1F5F9] font-medium mb-4">1. Geltungsbereich</h2>
                    <p className="mb-4">
                        Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge, Lieferungen und sonstigen Leistungen von Praesidium Protection (Inh. Magomed Tutaev), nachfolgend "Auftragnehmer" genannt, gegenüber ihren Auftraggebern. Abweichende Bedingungen des Auftraggebers werden nicht anerkannt, es sei denn, der Auftragnehmer stimmt ihrer Geltung ausdrücklich schriftlich zu.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl text-[#F1F5F9] font-medium mb-4">2. Vertragsgegenstand</h2>
                    <p className="mb-4">
                        Gegenstand des Vertrages ist die Erbringung von Sicherheitsdienstleistungen (z. B. Personenschutz, Objektschutz, Veranstaltungsschutz) durch den Auftragnehmer. Art und Umfang der Dienstleistung ergeben sich aus dem jeweiligen schriftlichen Angebot bzw. Vertrag.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl text-[#F1F5F9] font-medium mb-4">3. Mitwirkungspflichten des Auftraggebers</h2>
                    <p className="mb-4">
                        Der Auftraggeber verpflichtet sich, dem Auftragnehmer alle für die ordnungsgemäße Durchführung des Auftrages erforderlichen Informationen und Unterlagen rechtzeitig zur Verfügung zu stellen. Er hat den Auftragnehmer über alle ihm bekannten Gefährdungen und Risiken zu unterrichten, die für die Durchführung des Auftrages von Bedeutung sein könnten.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl text-[#F1F5F9] font-medium mb-4">4. Haftung</h2>
                    <p className="mb-4">
                        Der Auftragnehmer haftet für Schäden, die durch ihn oder seine Erfüllungsgehilfen vorsätzlich oder grob fahrlässig verursacht wurden. Für leichte Fahrlässigkeit haftet der Auftragnehmer nur bei Verletzung wesentlicher Vertragspflichten (Kardinalpflichten). In diesem Fall ist die Haftung auf den vertragstypischen, vorhersehbaren Schaden begrenzt.
                    </p>
                    <p className="mb-4">
                        Für Schäden, die auf unvollständige oder falsche Informationen des Auftraggebers zurückzuführen sind, übernimmt der Auftragnehmer keine Haftung.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl text-[#F1F5F9] font-medium mb-4">5. Zahlungsbedingungen</h2>
                    <p className="mb-4">
                        Soweit nicht anders vereinbart, sind Rechnungen sofort nach Erhalt ohne Abzug zahlbar. Bei Zahlungsverzug ist der Auftragnehmer berechtigt, Verzugszinsen in gesetzlicher Höhe zu fordern sowie die weitere Leistungserbringung bis zur vollständigen Zahlung einzustellen.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl text-[#F1F5F9] font-medium mb-4">6. Geheimhaltung</h2>
                    <p className="mb-4">
                        Der Auftragnehmer verpflichtet sich, über alle ihm im Zusammenhang mit der Auftragsausführung bekannt gewordenen geschäftlichen und privaten Angelegenheiten des Auftraggebers Stillschweigen zu bewahren. Diese Verpflichtung besteht auch über die Beendigung des Vertragsverhältnisses hinaus.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl text-[#F1F5F9] font-medium mb-4">7. Schlussbestimmungen</h2>
                    <p className="mb-4">
                        Es gilt das Recht der Bundesrepublik Deutschland. Gerichtsstand für alle Streitigkeiten aus diesem Vertrag ist, soweit gesetzlich zulässig, der Sitz des Auftragnehmers (Rielasingen-Worblingen/Singen). Sollten einzelne Bestimmungen dieses Vertrages unwirksam sein oder werden, so berührt dies die Wirksamkeit der übrigen Bestimmungen nicht.
                    </p>
                </section>
            </div>
        </div>
    );
};

